// app/javascript/utils/firebase/storage.js

import { app } from './initialise.js'; // Import the initialized Firebase app
import {
  onValue,
  off,
  child,
  ref,
  getDatabase,
} from 'firebase/database';

// Initialize Firebase Storage and associate it with your app
const database = getDatabase(app);

// Export the initialized storage instance AND common functions
// Exporting functions directly makes them easier to import elsewhere
export {
  onValue,              // The storage service instance
  ref,                  // Function to create storage references
  off, // Function for resumable uploads
  child,
  database
};

console.log("Firebase Storage initialized.");
